import { useCallback } from "react";
import Router from "next/router";

import { UrlsConfig } from "configs/urlsConfig";
import { BOOKING_FORM_ID } from "components/BookingForm/constants";
import { HEADER_ID } from "components/Header/constants";
import { scrollToElement } from "utils/scrollToElement";

const bookingPage = UrlsConfig.UNIVERSAL_FORM;
const bookingBlockId = BOOKING_FORM_ID;

export const useGoToBooking = () => {
    const goToBooking = useCallback(() => {
        const blockElement = document.getElementById(bookingBlockId);

        if (blockElement) {
            const headerElement = document.getElementById(HEADER_ID);
            const headerHeight = headerElement?.offsetHeight || 0;
            const defaultOffset = 24;
            const offset = headerHeight + defaultOffset;
            scrollToElement(blockElement, {
                offset,
                behavior: "smooth",
            });
        } else {
            Router.push(bookingPage);
        }
    }, []);

    return { goToBooking };
};
